<template>
  <span class="ui-expand-arrow expand-arrow" aria-hidden="true">
    <svg
      v-if="expanded"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
    <svg
      v-else
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="9 6 15 12 9 18" />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'ExpandArrowIcon',
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
